import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Button from '../Button';
import ghost2 from '../../images/ghost2.png';


const Header = () => (
  <header className="sticky top-0 bg-white shadow">
    <div className="container flex flex-col sm:flex-row justify-between items-center mx-auto py-4 px-8">
      <div className="flex items-center text-2xl">
        <AnchorLink href="#landing" className="w-12 mr-3">
          <img src={ghost2} alt="sailsbib market perspective aero" />
        </AnchorLink>
        <AnchorLink href="#landing" className='font-semibold text-black'>Sailsbib</AnchorLink>
      </div>
      <div className="flex mt-4 sm:mt-0">
        <AnchorLink className="px-4" href="#features">
          Features
        </AnchorLink>
        <AnchorLink className="px-4" href="#services">
          Services
        </AnchorLink>
        <AnchorLink className="px-4" href="#stats">
          Concepts
        </AnchorLink>
        <AnchorLink className="px-4" href="#testimonials">
          Prospects
        </AnchorLink>
      </div>
      <div className="hidden md:block">
        <a className="text-sm" href='https://gmail.us11.list-manage.com/subscribe/post?u=dd812a45e89d08f7548d0c06c&amp;id=cdb1ecdc5b&amp;f_id=00f10fe1f0'>
          <Button>Request a Quote</Button>
        </a>
      </div>
    </div>
  </header>
);

export default Header;
